import { PageEditTrayLayout } from '../page-edit-screen/page-edit-screen.view-model';

export const trayListLayoutAssets = {
  [PageEditTrayLayout.MarketingEmailCollectorCentered]: {
    src: '/assets/images/layout_marketing_email_collector.png',
    alt: 'layout_marketing_email_collector',
  },
  [PageEditTrayLayout.MarketingMultipleContentLandscape]: {
    src: '/assets/images/layout_marketing_multiple_content_landscape.png',
    alt: 'layout_marketing_multiple_content_landscape',
  },
  [PageEditTrayLayout.MarketingMultipleContentPortrait]: {
    src: '/assets/images/layout_marketing_multiple_content_portrait.png',
    alt: 'layout_marketing_multiple_content_portrait',
  },
  [PageEditTrayLayout.MarketingCTALeft]: {
    src: '/assets/images/layout_marketing_cta_left.png',
    alt: 'layout_marketing_cta_left',
  },
  [PageEditTrayLayout.MarketingCTARight]: {
    src: '/assets/images/layout_marketing_cta_right.png',
    alt: 'layout_marketing_cta_right',
  },
  [PageEditTrayLayout.Hero]: {
    src: '/assets/images/layout_hero.png',
    alt: 'layout_hero',
  },
  [PageEditTrayLayout.Branded]: {
    src: '/assets/images/layout_branded.png',
    alt: 'layout_branded',
  },
  [PageEditTrayLayout.Genre]: {
    src: '/assets/images/layout_genre.png',
    alt: 'layout_genre',
  },
  [PageEditTrayLayout.Kids]: {
    src: '/assets/images/layout_kids.png',
    alt: 'layout_kids',
  },
  [PageEditTrayLayout.Landscape]: {
    src: '/assets/images/layout_landscape_large.png',
    alt: 'layout_landscape',
  },
  [PageEditTrayLayout.Portrait]: {
    src: '/assets/images/layout_portrait_large.png',
    alt: 'layout_portrait',
  },
  [PageEditTrayLayout.Expandable]: {
    src: '/assets/images/layout_portrait_large.png',
    alt: 'layout_expandable',
  },
  [PageEditTrayLayout.Top10]: {
    src: '/assets/images/layout_top10.png',
    alt: 'layout_top10',
  },
  [PageEditTrayLayout.MarketingTrendingLeft]: {
    src: '/assets/images/layout_marketing_trending_left.png',
    alt: 'marketing_trending_left',
  },
  [PageEditTrayLayout.MarketingTrendingRight]: {
    src: '/assets/images/layout_marketing_trending_right.png',
    alt: 'marketing_trending_right',
  },
  [PageEditTrayLayout.MarketingEmailCollectorLeft]: {
    src: '/assets/images/layout_marketing_cta_left.png',
    alt: 'layout_marketing_email_collector',
  },
  [PageEditTrayLayout.MarketingEmailCollectorRight]: {
    src: '/assets/images/layout_marketing_cta_right.png',
    alt: 'layout_marketing_email_collector',
  },
  // TODO revisit assets
  [PageEditTrayLayout.StudiosSmall]: {
    src: '/assets/images/layout_landscape_small.png',
    alt: 'studios_small',
  },
  [PageEditTrayLayout.StudiosMedium]: {
    src: '/assets/images/layout_landscape_medium.png',
    alt: 'studios_medium',
  },
  [PageEditTrayLayout.StudiosLarge]: {
    src: '/assets/images/layout_studio_landscape_large.png',
    alt: 'studios_large',
  },
  [PageEditTrayLayout.MarketingDeviceModule]: {
    src: '/assets/images/layout_device_module.png',
    alt: 'marketing_device_module',
  },
  [PageEditTrayLayout.MarketingSpotlightTray]: {
    src: '/assets/images/layout_spotlight.png',
    alt: 'marketing_spotlight_tray',
  },
  [PageEditTrayLayout.MarketingEmailBlocker]: {
    src: '/assets/images/layout_email_blocker.png',
    alt: 'marketing_email_blocker',
  },
  [PageEditTrayLayout.LandscapeTwoCardsTray]: {
    src: '/assets/images/layout_landscape_large_2.png',
    alt: 'layout_landscape_large_2',
  },
  [PageEditTrayLayout.LandscapeThreeCardsTray]: {
    src: '/assets/images/layout_landscape_large_3.png',
    alt: 'layout_landscape_large_3',
  },
  [PageEditTrayLayout.LandscapeFourCardsTray]: {
    src: '/assets/images/layout_landscape_large_4.png',
    alt: 'layout_landscape_large_4',
  },
  [PageEditTrayLayout.MarketingCTATwoCard]: {
    src: '/assets/images/layout_marketing_cta_2.png',
    alt: 'layout_landscape_two_card',
  },
  [PageEditTrayLayout.MarketingCTAThreeCard]: {
    src: '/assets/images/layout_marketing_cta_3.png',
    alt: 'layout_landscape_three_card',
  },
  [PageEditTrayLayout.MarketingCTAFourCard]: {
    src: '/assets/images/layout_marketing_cta_4.png',
    alt: 'layout_landscape_four_card',
  },
  [PageEditTrayLayout.CarouselBannerTray]: {
    src: '/assets/images/layout_carousel_banner.png',
    alt: 'layout_carousel_banner',
  },
  [PageEditTrayLayout.BannersOnlyTray]: {
    src: '/assets/images/layout_banners_only.svg',
    alt: 'layout_banners_only',
  },
  [PageEditTrayLayout.SearchTagsTray]: {
    src: '/assets/images/layout_search_tags.svg',
    alt: 'layout_search_tags',
  },
  [PageEditTrayLayout.TopTenOnLiveTvTray]: {
    src: '/assets/images/layout_top_10_on_live_tv.svg',
    alt: 'layout_top_10_on_live_tv',
  },
  [PageEditTrayLayout.TrendingOnAppTray]: {
    src: '/assets/images/layout_trending_on_app.svg',
    alt: 'layout_trending_on_app',
  },
  [PageEditTrayLayout.LandscapePostersTray]: {
    src: '/assets/images/layout_landscape_posters_thumbnail.svg',
    alt: 'layout_landscape_posters_thumbnail',
  },
  [PageEditTrayLayout.MarketingBannerTray]: {
    src: '/assets/images/layout_marketing_banner.svg',
    alt: 'layout_marketing_banner',
  },
  [PageEditTrayLayout.TopTenOnOSNPlusPosterArtTray]: {
    src: '/assets/images/layout_top_10_osn.svg',
    alt: 'layout_top_10_osn',
  },
  [PageEditTrayLayout.ContinueWatchingTray]: {
    src: '/assets/images/layout_continue_watching.svg',
    alt: 'layout_continue_watching',
  },
  [PageEditTrayLayout.MarketingVideoTray]: {
    src: '/assets/images/layout_marketing_video.png',
    alt: 'layout_marketing_video',
  },
};
